import { z } from "zod";

export const TermoCadastroSchema = z.object({
    idTermo: z.number().int().optional(),
    codigo: z.string().nonempty({ message: "O código é obrigatório." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
    nome: z.string().optional().nullable(),
    ativo: z.coerce.boolean().default(true),

});

export type TermoCadastroForm = z.infer<typeof TermoCadastroSchema>;

export const defaultTermoCadastroForm: Partial<TermoCadastroForm> = {
    idTermo: undefined,
    codigo: undefined,
    descricao: undefined,
    nome: undefined,
    ativo: true,

};
